import { Component, inject } from '@angular/core';
import { CountryService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CountryCreateDto,
  CountryDto,
  CountryExcelDownloadDto,
  CountryUpdateDto,
} from '../proxy/planning/dtos/country';
import { COUNTRY_CONFIG, COUNTRY_FIELDS } from './country.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-country',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CountryService, ConfirmationService],
  templateUrl: './country.html',
  styleUrl: './country.scss',
})
export class Country extends BaseHierarchicalCrudComponent<
  CountryDto,
  CountryCreateDto,
  CountryUpdateDto,
  CountryExcelDownloadDto
> {
  service = inject(CountryService);
  config = COUNTRY_CONFIG;
  fields = COUNTRY_FIELDS;

  protected prepareUpdateDto(data: any, selected: CountryDto): CountryUpdateDto {
    return {
      name: data.name,
      code: data.code,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Country';
  }
}
